import React, {Component} from 'react'
import {connect} from 'react-redux'
import ModalApp from "../../../SharedComponents/Modal"
import PlanDisplay from "../../../SharedComponents/Payment/PlanDisplay"

class PlanDetailsModal extends Component {
    render() {
        return (
            <ModalApp name="planDetailsModal"
                      header={null}
                      body={<PlanDisplay />}
                      size="small"
            />
        )
    }
}

const mapStateToProps = (state) => ({})

const mapActionsToProps = {}

export default connect(mapStateToProps, mapActionsToProps)(PlanDetailsModal)